import { css } from 'styled-components';

export const formGroupStyles = css`
  .form-group {
    &.success {
      color: green;

      .form-control {
        border-color: green;
        &:focus {
          box-shadow:
            inset 0 1px 1px rgb(0 0 0 / 8%),
            0 0 6px #67b168;
        }
      }
    }

    &.error {
      color: #c00;

      .form-control {
        border-color: #c00;
        &:focus {
          box-shadow:
            inset 0 1px 1px rgb(0 0 0 / 8%),
            0 0 6px #d33422;
        }
      }
    }

    .form-label {
      font-size: 0.9rem;
      margin: 0;
    }
  }

  .error-message {
    color: #c00;
    font-weight: bold;
    font-size: 0.9rem;
  }
`;

export const formContainerStyles = css`
  margin-top: 50px;
  width: 30%;
  min-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow:
    rgba(6, 24, 44, 0.4) 0px 0px 0px 2px,
    rgba(6, 24, 44, 0.65) 0px 4px 6px -1px,
    rgba(255, 255, 255, 0.08) 0px 1px 0px inset;

  padding: 40px 30px;
`;
